// extracted by mini-css-extract-plugin
export default {"subscription_item_price":"Yx","delete_item":"Zx","subscription_item":"ay","subscription_item_img_wrapper":"by","subscription_item_info":"cy","subscription_item_title":"ey","subscription_item_edit":"fy","subscription_item_wrapper":"gy","arrow":"hy","subscription_item_category":"iy","plus_button":"jy","more_details":"ky","old_price":"ly","discount":"my"};
    if(module.hot) {
      // 1713996746817
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  